export enum AutopilotTimeUnitsEnum {
    None,
    sec,
    min,
    date
}